import { MDBBtn, MDBChip, MDBIcon, MDBInputGroup, MDBModalFooter, MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../../components/CustomSearchUtil/CustomSearch";
const AddLocation = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const [existingLocations, setExistingLocations] = useState([]);
    const [newAddedLocations, setNewAddedLocations] = useState([]);

    const [allLocations, setAllLocations] = useState([]);

    const [searchSourceQuery, setSearchSourceQuery] = useState('');
    const [searchDetinationQuery, setSearchDetinationQuery] = useState('');
    const [selectedRowsUniqueIds, setSelectedRowsUniqueIds] = useState(new Set());//It contains added location Ids and also used for unique idenification of locations for better performance.
    const [existingUniqueIds, setExistingUniqueIds] = useState(new Set());
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    useAutoFocusSearchAfterLoads(dataLoaded, setDataLoaded, searchRef, true)

    const columns = [
        { label: "Name", field: "location_name", sort: true },
        { label: "Address", field: "address" },
    ];


    useEffect(() => {
        if (props.existingLocations && props.existingLocations?.length > 0) {
            setExistingLocations(props.existingLocations);
            let existingUniqueIds = props.existingLocations.map(obj => obj.location_id);
            setSelectedRowsUniqueIds(new Set(existingUniqueIds));
            setExistingUniqueIds(new Set(existingUniqueIds));
        }
        if (props.allLocations?.length > 0) {
            setAllLocations(props.allLocations);
        }
        setDataLoaded(true);

    }, [props.existingLocations, props.allLocations]);



    function onClickAddLocation(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log(`Locatio UniqyeID::${Array.from(selectedRowsUniqueIds)}`);
        console.log(`Added locations::${JSON.stringify(newAddedLocations)}`);
        props.setAddedLocations(newAddedLocations);
        //close popuping intimation from child to parent.
        props.closingPopup(true);
        props.onClose();
    }

    function setSelectAll(e) {
        e.preventDefault();
        e.stopPropagation();

        // Updating select All case.
        const selectedRowsSet = new Set(selectedRowsUniqueIds);
        let listaddedLoc = [...newAddedLocations];
        // filter by current search query
        const filteredLocations = customSearch(allLocations, searchSourceQuery, ["location_name", "address"])

        
        if (filteredLocations.length === 0) {
            return;}
        allLocations.forEach((ele) => {
            if (!(selectedRowsSet.has(ele.location_id))) { // Adding only the data which are not yet added.
                selectedRowsSet.add(ele.location_id);
                listaddedLoc.push(ele);
            }
        });
        setNewAddedLocations(listaddedLoc);
        setSelectedRowsUniqueIds(selectedRowsSet);
    }

    const handleRowClick = (uniqueId, selectedObj) => {
        try {
            if (!existingUniqueIds.has(uniqueId)) {
                const selectedRowsSet = new Set(selectedRowsUniqueIds);
                let alreadyAddedLoc = newAddedLocations ?? [];
                if (selectedRowsSet.has(uniqueId)) { // Removing the locatins
                    selectedRowsSet.delete(uniqueId); // newAddedLocations
                    for (let index = 0; index < newAddedLocations.length; index++) { // deletes the object.
                        if (newAddedLocations[index].location_id === uniqueId) {
                            newAddedLocations.splice(index, 1);
                            break;
                        }
                    }
                } else { // Adding the locations.
                    selectedRowsSet.add(uniqueId);
                    alreadyAddedLoc.push(selectedObj);
                }
                setSelectedRowsUniqueIds(selectedRowsSet);
                setNewAddedLocations(alreadyAddedLoc);
            }
        } catch (error) {
        }
    }


    return (
        <>
            <div>
                <div className="pt-3">
                    {(newAddedLocations.length>0 || existingLocations.length>0) && (
                    <MDBInputGroup className='mb-3' textAfter={<MDBIcon fas icon='search' />}>
                        <input className='form-control' type='text' placeholder='Search'
                            value={searchDetinationQuery}
                            onChange={(e) => setSearchDetinationQuery(e.target.value)}
                        />
                    </MDBInputGroup>)}
                    <div className="form-group row">
                        <div className="col-12">
                            <div className="form-outlines phoneNumberheight p-0">
                                <div className="chips chips-placeholder">
                                {(existingLocations && existingLocations.length > 0 || newAddedLocations && newAddedLocations.length > 0) ?( <>
                                    {existingLocations && existingLocations.length > 0 &&
                                    customSearch(existingLocations, searchDetinationQuery, ["location_name"])

                                            .map((item) =>(
                                              
                                                (
                                                    <MDBChip
                                                        key={item.location_id ?? item.loc_id} className="m-chip d-inline py-2 px-3">
                                                        {item.location_name}
                                                    </MDBChip>
                                                )
                                            )) 
                                    
                                    }

                                    {newAddedLocations && newAddedLocations.length > 0 && (
                                       customSearch(newAddedLocations, searchDetinationQuery, ["location_name", "address"])
                                        .map((item) =>(

                                                
                                                    <MDBChip
                                                        onDelete={() => handleRowClick(item.location_id, item)} className="m-chip d-inline py-2 px-3"
                                                        key={item.location_id ?? item.loc_id} closeIcon size="sm">
                                                        {item.location_name}
                                                    </MDBChip>
                                            ))
                                    )}
                                       </> ): <>
                                        <p className='m-1 text-secondary'>
                                            The selected Locations will appear in this section
                                        </p>
                                    </>}

                                </div>
                            </div>
                            <label className="my-3 text-primary cursor-pointer " onClick={(e) => setSelectAll(e)}>
                                {t("selectAll")}
                            </label>
                            <MDBInputGroup className='mb-3' textAfter={<MDBIcon fas icon='search' />}>
                                <input className='form-control' ref={searchRef} type='text' placeholder='Search'
                                    value={searchSourceQuery}
                                    onChange={(e) => setSearchSourceQuery(e.target.value)} />
                            </MDBInputGroup>
                            <div className="addAdminTable_height">
                                <MDBTable className="mt-3"
                                    hover
                                    itemScope
                                    small
                                >
                                    <MDBTableHead className="table-header-sticky">
                                        <tr >
                                            {columns &&
                                                columns.map((col) => {
                                                    return (
                                                        <th scope='col' key={col.field}>
                                                            {col.label}
                                                        </th>
                                                    );
                                                })}
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                        {allLocations?.length > 0 &&
                                            customSearch(allLocations, searchSourceQuery, ["location_name", "address"])

                                            .map((row) =>{

                                               return(
                                                (
                                                    <tr
                                                        className={selectedRowsUniqueIds?.has(row.location_id) ? 'addUsers-select' : ''}
                                                        onClick={() => handleRowClick(row.location_id, row)}>

                                                        {columns.map((column) => (

                                                            <td className="cursor-pointer">
                                                                {row[column.field]}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))})
                                                
                                        }
                                        {(allLocations == undefined || allLocations?.length == 0) &&
                                            <td colSpan={columns?.length ?? 2} className="text-center">
                                                No records found
                                            </td>
                                        }
                                    </MDBTableBody>
                                </MDBTable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div style={{ display: "none" }}>
                <button ref = {ref} onClick={(e) => {e.stopPropagation(); e.preventDefault(); onClickAddLocation(e)}}>
                    {t("add")}</button>
            </div>

            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                    {t("close")}
                </MDBBtn>
                <MDBBtn onClick={(e) => onClickAddLocation(e)}>{t("add")}</MDBBtn>
            </MDBModalFooter> */}
        </>
    )
});
export default AddLocation;